(() => {
  const viewportSelector = '.mce-brands__viewport';
  const normalRate = 1;
  const edgeRate = 2.25;
  const finePointer = window.matchMedia(
    '(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)'
  );

  const getTrackAnimation = (track) => {
    const animations = track.getAnimations();

    return animations.find((animation) => animation.animationName === 'mce-brands-marquee') || animations[0];
  };

  const bindViewport = (viewport) => {
    if (viewport.dataset.mceBrandsEdgeSpeed === 'true') {
      return;
    }

    const track = viewport.querySelector('.mce-brands__track');

    if (!track) {
      return;
    }

    viewport.dataset.mceBrandsEdgeSpeed = 'true';

    let animation;
    let bounds;
    let playbackRate = normalRate;

    const setPlaybackRate = (nextRate) => {
      if (nextRate === playbackRate) {
        return;
      }

      if (!animation || animation.playState === 'idle') {
        animation = getTrackAnimation(track);
      }

      if (!animation || typeof animation.updatePlaybackRate !== 'function') {
        playbackRate = normalRate;
        return;
      }

      animation.updatePlaybackRate(nextRate);
      playbackRate = nextRate;
    };

    const updateFromPointer = (event) => {
      if (!finePointer.matches) {
        setPlaybackRate(normalRate);
        return;
      }

      if (!bounds) {
        bounds = viewport.getBoundingClientRect();
      }

      const edgeThreshold = Math.min(110, Math.max(70, bounds.width * 0.08));
      const pointerOffset = event.clientX - bounds.left;
      const isNearEdge =
        pointerOffset <= edgeThreshold || pointerOffset >= bounds.width - edgeThreshold;

      setPlaybackRate(isNearEdge ? edgeRate : normalRate);
    };

    const resetPlaybackRate = () => {
      bounds = null;
      setPlaybackRate(normalRate);
    };

    viewport.addEventListener('pointerenter', (event) => {
      bounds = viewport.getBoundingClientRect();
      updateFromPointer(event);
    });
    viewport.addEventListener('pointermove', updateFromPointer, { passive: true });
    viewport.addEventListener('pointerleave', resetPlaybackRate);
    viewport.addEventListener('pointercancel', resetPlaybackRate);
    viewport.mceBrandsResetPlaybackRate = resetPlaybackRate;
  };

  const initialize = (root = document) => {
    if (!finePointer.matches) {
      return;
    }

    root.querySelectorAll(viewportSelector).forEach(bindViewport);
  };

  if (window.mceBrandsMarqueeController) {
    window.mceBrandsMarqueeController.initialize(document);
    return;
  }

  window.mceBrandsMarqueeController = { initialize };
  initialize(document);

  finePointer.addEventListener('change', (event) => {
    if (event.matches) {
      initialize(document);
      return;
    }

    document.querySelectorAll(viewportSelector).forEach((viewport) => {
      if (typeof viewport.mceBrandsResetPlaybackRate === 'function') {
        viewport.mceBrandsResetPlaybackRate();
      }
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
